<template lang="pug">
  #app
    .app-contain
      keep-alive
        router-view(v-if="isRouterAlive && $route.meta.keepAlive")
      router-view(v-if="isRouterAlive && !$route.meta.keepAlive")
</template>
<script>
import { mapState } from 'vuex';
import './styles/global/entities.styl';

export default {
    computed: {
        ...mapState(['isRouterAlive']),
    },
    data() {
        return {
        };
    },
};
</script>
<style lang="stylus">
.project_body{
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
}
.project_body_no_bottom {
    padding-bottom: 0px;
}
html,body
  height 100%
  font-family -apple-system,BlinkMacSystemFont,Helvetica Neue,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif
#app
  width 100vw
  height 100%
  background-color use-token(color-fill1)
  color use-token(color-text1)
  .app-contain
    height 100%
    overflow-y auto
    -webkit-overflow-scrolling touch

.center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
body .hevue-imgpreview-wrap .he-img-wrap { // 图片预览修改组件内部样式
  background: rgba(0, 0, 0, .9);
}
</style>
